module.exports = __webpack_public_path__ + "img/ardrive.2302d91e.png";